/* eslint-disable react-hooks/exhaustive-deps */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "reactstrap";
import { useCultivo } from "../../../r_proyeccion_diaria/hooks/useCultivo";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { useNotificationNumbers } from "../../../../hooks/useNotification.Numbers";
import { useUserCampo } from "../../../../hooks/useUserCampos";
import { Button } from "../../../../components/ui/button";
import { Input } from "../../../../components/ui/input";
import { Select } from "../../../../components/ui/select";

export const ReporteDiariaFilter = ({
  values,
  errors,
  touched,
  handleSubmit,
  handleChange,
  setFieldValue,
  loading,
}) => {
  const { getCultivo } = useCultivo();
  const { getNotificationNumbers } = useNotificationNumbers();
  const { getCampos } = useUserCampo();
  const user = localStorage.getItem("@usuario");
  const json_user = JSON.parse(user);

  const [cultivosOptions, setCultivosOptions] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const [camposOptions, setCamposOptions] = useState([]);
  const [selectedCampo, setSelectedCampo] = useState(0);

  const sendNotifications = () => {
    if (numbers.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Favor de comunicarlo con el equipo de desarrollo",
        text: "No hay numeros a donde mandar notificaciones",
      });
      return;
    }

    Swal.fire({
      icon: "info",
      title: "Enviar notificación",
      text: "¿Está seguro de que desea enviar la notificación?",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        let current_campo = localStorage.getItem("Campo");
        if (current_campo.toUpperCase().includes("DON MARIO")) {
          current_campo = "DON MARIO";
        }
        await numbers.reduce(async (promise, current) => {
          await promise;
          var data = JSON.stringify({
            token: process.env.REACT_APP_NOTIFICATION_TOKEN,
            to: current.number,
            body: `✉️ Notificación automática: 

Les informamos que ${json_user.nombre} ${
              json_user.apellido
            } ha capturado la proyección de cosecha del dia 📅 ${moment(
              values.inicio,
            ).format("DD/MM/YYYY")} al día ${moment(values.fin).format(
              "DD/MM/YYYY",
            )} del campo ${current_campo} y se encuentra disponible en la plataforma, favor de verificarlo ✅`,
          });

          var config = {
            method: "post",
            url: `https://api.ultramsg.com/${process.env.REACT_APP_NOTIFICATION_INSTANCE}/messages/chat`,
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };
          try {
            await axios(config);
          } catch (error) {
            Swal.showValidationMessage(
              `Error - Favor de comunicarlo con el equipo de desarrollo`,
            );
            return;
          }
        }, Promise.resolve());
      },
      allowOutsideClick: () => {
        return !Swal.isLoading();
      },
      backdrop: true,
    }).then(async (res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Notificaciones enviadas",
          timer: 1500,
        });
      }
    });
  };

  const handleSelectCampo = (e) => {
    const id_campo = e.target.value;
    setSelectedCampo(id_campo);
    if (
      !values.campos.some((item) => item === id_campo) &&
      Number(id_campo) !== 0
    ) {
      setFieldValue("campos", [...values.campos, id_campo]);
    }
  };

  const onFilterCampoClick = (id_campo) => {
    setFieldValue(
      "campos",
      values.campos.filter((item) => Number(item) !== Number(id_campo)),
    );
  };

  useEffect(() => {
    const getNumbers = async () => {
      const response = await getNotificationNumbers("diaria");
      setNumbers(response);
    };
    const getCultivosOptions = async () => {
      const response = await getCultivo();
      setCultivosOptions(response);
      if (response && response.length === 1) {
        setFieldValue("cultivo", response[0].idcultivo);
      }
    };
    const getCampoOptions = async () => {
      const response = await getCampos();
      setCamposOptions(response);
    };
    getNumbers();
    getCultivosOptions();
    getCampoOptions();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col md={2}>
          <label>Cultivo</label>
          <Select
            disabled={cultivosOptions.length === 1}
            value={values.cultivo}
            onChange={handleChange}
            name="cultivo"
          >
            <option value="">Seleccionar...</option>
            {cultivosOptions.map((item) => (
              <option value={item.idcultivo} key={item.idcultivo}>
                {item.cultivo}
              </option>
            ))}
          </Select>
        </Col>
        <Col md={2}>
          <label>Fecha inicio</label>
          <Input
            value={values.inicio}
            type="date"
            name="inicio"
            onChange={handleChange}
            style={
              (errors.inicio && touched.inicio) !== undefined
                ? styles.error
                : {}
            }
          />
        </Col>
        <Col md={2}>
          <label>Fecha fin</label>
          <Input
            value={values.fin}
            type="date"
            name="fin"
            onChange={handleChange}
            style={
              (errors.fin && touched.fin) !== undefined ? styles.error : {}
            }
          />
        </Col>
        <Col md={2}>
          <label>Campo</label>
          <Select value={selectedCampo} onChange={handleSelectCampo}>
            <option value={0}>Seleccionar...</option>
            {camposOptions.map((item) => (
              <option value={item.idcampo} key={item.idcampo}>
                {item.campo}
              </option>
            ))}
          </Select>
        </Col>
        <Col md={2}>
          <div className="mt-4" />
          <button className="btn btn-success" type="sumbit" disabled={loading}>
            {loading ? <FontAwesomeIcon icon={"spinner"} spin /> : "Buscar"}
          </button>{" "}
          <button
            type="button"
            onClick={sendNotifications}
            className="btn btn-outline-success"
          >
            <FontAwesomeIcon icon="fab fa-whatsapp" />
          </button>
        </Col>
      </Row>
      <br />
      {values.campos.length > 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            style={{
              maxWidth: "500px",
              minWidth: "150px",
              overflowX: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "nowrap",
                gap: "4px",
              }}
            >
              {values.campos.map((item) => (
                <Button
                  key={item}
                  variant="link"
                  onClick={() => onFilterCampoClick(item)}
                  style={{ flexShrink: 0 }}
                >
                  {camposOptions.find((campo) => campo.idcampo === Number(item))
                    ?.campo ?? ""}
                </Button>
              ))}
            </div>
          </div>

          <Button
            variant="outline"
            type="button"
            onClick={() => setFieldValue("campos", [])}
          >
            Limpiar filtros
          </Button>
        </div>
      )}
    </form>
  );
};

const styles = {
  error: {
    borderColor: "red",
  },
  btn_clear: {
    backgroundColor: "#ffd0d0",
    color: "red",
  },
  btn: {
    borderRadius: "10px",
    borderWidth: "1px",
    padding: "5px",
    backgroundColor: "#e0f2fe",
    borderColor: "#3b82f6",
    fontSize: "12px",
  },
};
